import {
  Cookiebanner,
  cookiebannerTemplateTablist,
  cookiebannerLabels,
} from '@3pc/cookiebanner';
import { initConsentOverlays } from '../consent-overlay/consent-overlay';

// Consent overlays

const consentOverlays = initConsentOverlays();

// // tracking:
const isProduction = document.body.hasAttribute('data-production');
const siteId = document.body.getAttribute('data-trackingId');
const consentAdditions = document.body.dataset.consentAddition || [];
const matomoSiteId = isProduction ? siteId : 'QA.LINUX15.PROPERTY.ID';
const matomoUrl = isProduction
  ? '//statistik.vdk.de/'
  : 'https://qa.linux15.3pc.de/matomo/';
// // hiding the cookiebanner on certain pages (here: privacy policy and imprint):
const hideCookiebanner = document.body.hasAttribute('data-hide-cookiebanner');
const imprint =
  document.querySelector('[data-imprint-link]') &&
  JSON.parse(document.querySelector('[data-imprint-link]').dataset.imprintLink);
const privacyPolicy =
  document.querySelector('[data-privacy-policy-link]') &&
  JSON.parse(
    document.querySelector('[data-privacy-policy-link]').dataset
      .privacyPolicyLink
  );

const additionalConsentTypes = [
  {
    name: {
      de: 'Social-Media-Dienst TikTok',
      en: 'TikTok',
    },
    text: {
      de: '<p>Der Sozialverband VdK Nord greift für den angebotenen Informationsdienst auf die technische Plattform und die Dienste der TikTok Technology Limited, 10 Earlsfort Terrace, Dublin, D02 T380, Irland (im Folgenden: „TikTok“) zurück. Für den TikTok-Kanal @vdk_nord hat der VdK Nord die TikTok-Analytics-Funktion deaktiviert. D.h. TikTok stellt dem VdK Nord keine Seitenstatistik, die anonymisiert Aufschluss über Besuchergruppen und Besucheraktivitäten gibt, zur Verfügung. Das sog. „TikTok Analytics Joint Controller Addendum“ gilt daher für diesen Informationsdienst nicht.</p><p>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</p>',
      en: 'Text || Podigee content.',
    },
    type: 'tiktok',
  },
];
// consentTypes:
const consentTypes = [
  {
    name: {
      de: 'Notwendige Cookies',
      en: 'Essential Cookies',
    },
    text: {
      de: '<p>Diese sind für den Betrieb unserer Websites technisch notwendig und immer aktiviert. Hierzu zählen z.B. sogenannte Session-Cookies, die nach Ende Ihres Besuchs automatisch gelöscht werden.</p>',
      en: 'Text || Required Cookies.',
    },
    type: 'required',
    showInInfoPanel: true,
  },
  {
    name: {
      de: 'Webstatistik (Matomo) Cookies',
      en: 'Matomo',
    },
    text: {
      de: '<p>Mit Hilfe der Tracking-Cookies erheben wir statistische Daten über die Nutzung unserer Website. Die Software Matomo ist dafür auf unseren eigenen Servern installiert. Die Daten werden nicht an Dritte weitergegeben. Die Analyse dieser Daten ermöglicht es uns, unser Webangebot für Sie weiterzuentwickeln und ständig zu verbessern.</p><p>Sämtliche Daten für Statistiken und Analysen erfassen wir anonymisiert, dazu wird u.a. Ihre IP-Adresse verfremdet.</p>',
      en: 'Text || Matomo.',
    },
    type: 'matomo',
    showInInfoPanel: true,
    trackingScripts: [
      {
        insertSelector: 'body',
        script:
          'var _paq = window._paq = window._paq || [];\n' +
          "_paq.push(['trackPageView']);\n" +
          "_paq.push(['enableLinkTracking']);\n" +
          '(function() {\n' +
          `var u="${matomoUrl}";\n` +
          "_paq.push(['setTrackerUrl', u+'matomo.php']);\n" +
          `_paq.push(['setSiteId', '${matomoSiteId}']);\n` +
          "var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n" +
          "g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);\n" +
          '})();',
      },
    ],
  },
  {
    name: {
      de: 'Video Cookies',
      en: 'Video',
    },
    text: {
      de: '<p>Mit unseren Videos möchten wir Sie über unsere Angebote informieren. Wir binden diese Videos von unseren eigenen YouTube-Kanälen im erweiterten Datenschutzmodus ein. YouTube ist ein Plattform-Dienst der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.</p><p>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</p>',
      en: 'Text || Youtube content.',
    },
    type: 'youtube',
  },
  {
    name: {
      de: 'Eingebettete Inhalte',
      en: 'Iframes',
    },
    text: {
      de: '<p>Um Ihnen erweiterte Funktionen und Services auf unseren Websites anzubieten, betten wir auf unseren Internetseiten ausgewählte Inhalte von Fremdbetreibern bzw. Dienstleistern ein. Dies betrifft insbesondere einige Formulare.</p><p>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</p>',
      en: 'Text || Iframes.',
    },
    type: 'iframe',
  },
  {
    name: {
      de: 'Podcast-Hosting-Dienst Podigee',
      en: 'Podigee',
    },
    text: {
      de: '<p>Wir nutzen den Dienst des Anbieters Podigee GmbH, Schlesische Straße 20, 10997 Berlin, Deutschland. Die Podcasts werden von Podigee geladen bzw. über Podigee übertragen.</p><p>Die Nutzung erfolgt auf Grundlage unserer berechtigten Interessen, das heißt Interesse an einer sicheren und effizienten Bereitstellung, Analyse sowie Optimierung unseres Podcast-Angebotes gemäß Artikel 6 Absatz 1 lit. f. DSGVO.</p><p>Podigee verarbeitet IP-Adressen und Geräteinformationen, um Podcast-Downloads/ Wiedergaben zu ermöglichen und statistische Daten, z.B. Abrufzahlen zu ermitteln. Diese werden vor der Speicherung in der Datenbank von Podigee verfremdet, sofern sie für die Bereitstellung der Podcasts nicht erforderlich sind.</p>',
      en: 'Text || Podigee content.',
    },
    type: 'podigee',
  },
  ...additionalConsentTypes.filter(consent =>
    consentAdditions.includes(consent.type)
  ),
];

cookiebannerLabels.mainPanelTitle = {
  de: 'Wir benötigen Ihre Zustimmung für den Einsatz von Cookies',
  en: 'Your cookie settings',
};

cookiebannerLabels.mainPanelText = {
  de: '<p>Um unsere Website im Sinne der Nutzerfreundlichkeit, Effektivität und Sicherheit für Sie zu optimieren, verwenden wir <strong>Cookies</strong>. Das sind kleine Textdateien, die auf Ihrem Computer, Laptop, Tablet oder Smartphone abgelegt und in Ihrem Browser gespeichert werden.</p><p>Einige Cookies sind technisch für den Betrieb unserer Websites notwendig. Weitere Cookies dienen der anonymen Webanalyse oder ermöglichen erweiterte Funktionen und Services. Mehr Informationen dazu finden Sie <a class="styled-link" href="/datenschutz/">in unserer Datenschutzerklärung</a>.</p><p>Sie entscheiden, welche Cookies zum Einsatz kommen sollen, wenn Sie die Website des VdK nutzen, und welche nicht. Bitte beachten Sie, dass Ihnen je nach Auswahl gegebenenfalls nicht mehr alle Funktionen unseres Webangebots zur Verfügung stehen.</p>',
  en: '<p>We use cookies to optimize the user-friendliness, effectiveness, and security of our websites for you. Cookies are little text files that are deposited on your data terminal and stored in your browser.<br/>Among these, are cookies that are essential to the technical functionality of our websites, as well as cookies for anonymous web analysis or expanded functions and services. Further information on cookies can be found in our <a href="en/privacy-policy">data privacy statement</a> (in German only).<br/>You decide which categories you want to approve the use of cookies for and which ones you do not want to approve. Please keep in mind that making certain selections may mean that some of the features of our websites will no longer be available to you.</p>',
};

// init Cookiebanner
isProduction &&
  new Cookiebanner({
    nameSpace: 'vdk',
    consentButtonTypes: 'required-all',
    cookiebannerTemplate: cookiebannerTemplateTablist,
    showTemplateMinimalInfoPanel: true,
    labels: cookiebannerLabels,
    hideCookiebanner,
    privacyPolicy,
    imprint,
    consentTypes,
    onInit: () => {
      // e.g. init ConsentOverlay
    },
    onRender: () => {
      // do stuff when cookiebanner is rendered
    },
    onOptIn: function (consentType) {
      consentOverlays.forEach(overlay => {
        if (consentType.type === overlay.consentType) overlay.toggleAll();
      });
    },
    onOptOut: function (consentType) {
      consentOverlays.forEach(overlay => {
        if (consentType.type === overlay.consentType) overlay.toggleAll();
      });
    },
    onTrackingEnabled: consentType => {
      // e.g. init event tracking
    },
  }).init();
